<script setup lang="ts">

</script>

<template>
  <div class="logo-flyout">
    <img src="/logo.png" alt="Altracare logo">
  </div>
</template>

<style lang="scss" scoped>
.logo-flyout {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem 0;

  img {
    max-width: 160px;
    height: auto;
    display: block;
  }
}
</style>
